import { CLOUD, loggedIn } from '../cloud/api.js';
import { openHelp } from '../help.js';
import { t } from '../i18n/index.js';
import { S } from '../state.js';
import { IC, esc } from '../ui.js';

/* Contact & feedback: a real form (topic, subject, message, reply address), sent through Netlify Forms
   to kontakt@plumeplaner.de. Technical details are attached only if the user leaves the box ticked. */
const TYPES=['question','bug','idea','billing','privacy','other'];
const VERSION=typeof __APP_VERSION__!=='undefined'?__APP_VERSION__:'web';

export function vContact(){
  const email=(loggedIn()&&CLOUD.auth&&CLOUD.auth.email)||'';
  return `<div class="viewhead"><div><h1>${t('ct.title')}</h1><p class="muted" style="margin-top:4px">${t('ct.lead')}</p></div></div>
  <div class="contactgrid">
    <form class="card contactform" id="ct-form" novalidate>
      <div class="field"><label id="ct-type-l">${t('ct.type')}</label>
        <div class="chips" role="radiogroup" aria-labelledby="ct-type-l">${TYPES.map((k,i)=>`<button type="button" class="chip" role="radio" aria-checked="${i===0}" aria-pressed="${i===0}" data-type="${k}">${t('ct.t.'+k)}</button>`).join('')}</div></div>
      <div class="field"><label for="ct-subject">${t('ct.subject')}</label><input class="input" id="ct-subject" maxlength="140" placeholder="${esc(t('ct.subjectPh'))}"></div>
      <div class="field"><label for="ct-msg">${t('ct.msg')}</label><textarea class="textarea" id="ct-msg" rows="7" maxlength="5000" placeholder="${esc(t('ct.msgPh.question'))}"></textarea><p class="fielderr" id="ct-msg-err" hidden>${t('ct.msgShort')}</p></div>
      <div class="field"><label for="ct-email">${t('ct.email')}</label><input class="input" id="ct-email" type="email" autocomplete="email" value="${esc(email)}"><p class="fielderr" id="ct-email-err" hidden>${t('ct.emailBad')}</p></div>
      <label class="check"><input type="checkbox" id="ct-meta" checked> ${t('ct.meta')}</label>
      <p class="fielderr" id="ct-err" hidden></p>
      <div class="row mt" style="justify-content:flex-end"><button class="btn primary" type="submit" id="ct-send">${IC.mail} ${t('ct.send')}</button></div>
    </form>
    <div class="ct-done card" id="ct-done" hidden>
      <div class="ct-ok">${IC.check}</div><h2>${t('ct.doneTitle')}</h2><p class="muted">${t('ct.doneText')}</p>
      <button class="btn mt" data-ct="again">${t('ct.again')}</button>
    </div>
    <aside class="card ct-side">
      <h3 class="cardsub">${t('ct.faster')}</h3>
      <p class="muted mb8" style="font-size:13.5px">${t('ct.fasterText')}</p>
      <button class="btn small" data-ct="help">${t('pm.help')}</button>
      <div class="divider"></div>
      <p class="tiny">${t('ct.direct')} <a href="mailto:kontakt@plumeplaner.de">kontakt@plumeplaner.de</a></p>
    </aside>
  </div>`;
}

export function bindContact(m){
  const q=x=>m.querySelector(x);
  let type='question';
  m.querySelectorAll('[data-type]').forEach(b=>b.onclick=()=>{
    type=b.dataset.type;
    m.querySelectorAll('[data-type]').forEach(x=>{const on=x===b;x.setAttribute('aria-pressed',on);x.setAttribute('aria-checked',on)});
    q('#ct-msg').placeholder=t('ct.msgPh.'+type)||t('ct.msgPh.question');
  });
  q('[data-ct=help]').onclick=()=>openHelp();
  q('[data-ct=again]').onclick=()=>{q('#ct-done').hidden=true;q('#ct-form').hidden=false;q('#ct-subject').value='';q('#ct-msg').value=''};
  q('#ct-form').onsubmit=async e=>{
    e.preventDefault();
    const msg=q('#ct-msg').value.trim(),mail=q('#ct-email').value.trim();
    q('#ct-msg-err').hidden=msg.length>=10;q('#ct-email-err').hidden=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail);
    if(msg.length<10){q('#ct-msg').focus();return}
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)){q('#ct-email').focus();return}
    const btn=q('#ct-send');btn.disabled=true;btn.classList.add('busy');q('#ct-err').hidden=true;
    const meta=q('#ct-meta').checked?[`App: ${VERSION}`,`Sprache: ${S.settings.lang}`,`Bildschirm: ${innerWidth}×${innerHeight}`,`Gerät: ${navigator.userAgent}`,`Konto: ${loggedIn()?CLOUD.auth.email:'—'}`].join('\n'):'';
    const body=new URLSearchParams({'form-name':'contact','bot-field':'',type:t('ct.t.'+type),subject:q('#ct-subject').value.trim()||t('ct.t.'+type),message:msg,email:mail,name:S.settings.teacher||'',meta});
    try{
      const r=await fetch('/',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:body.toString()});
      if(!r.ok)throw new Error('HTTP '+r.status);
      q('#ct-form').hidden=true;q('#ct-done').hidden=false;
    }catch(err){
      q('#ct-err').innerHTML=t('ct.err',{mail:'<a href="mailto:kontakt@plumeplaner.de">kontakt@plumeplaner.de</a>'});q('#ct-err').hidden=false;
    }finally{btn.disabled=false;btn.classList.remove('busy')}
  };
}
